export type AccountResumeStatusIds = readonly [string, string]

export const ACCOUNT_RESUME_STATUS = {
  DRAFT: ['5f2d3d4375c5d', '1122'],
  PENDING_MODERATE: ['5f2d3d4376bf6', '1123'],
  VISIBLE: ['5f2d3d43794dd', '1126'],
  HIDDEN: ['5f2d3d4379ff1', '1127'],
  SUSPICIOUS: ['5f2d3d4377bb2', '1124'],
  BLOCKED: ['5f2d3d4378962', '1125'],
} satisfies Record<string, AccountResumeStatusIds>

export const ACCOUNT_RESUME_PUBLISHING_STATUS = {
  APPROVED: 'Одобрено',
  REJECTED: 'Отклонено',
  ON_REVIEW: 'На проверке',
  HIDDEN: 'Скрыт',
  DRAFT: 'Черновик',
} as const

export type AccountResumePublishingStatus =
  (typeof ACCOUNT_RESUME_PUBLISHING_STATUS)[keyof typeof ACCOUNT_RESUME_PUBLISHING_STATUS]

export type AccountResumeStatusTheme = 'approved' | 'rejected' | 'review' | 'hidden' | 'draft'

export const ACCOUNT_RESUME_PUBLISHING_STATUS_THEME: Record<string, AccountResumeStatusTheme> = {
  [ACCOUNT_RESUME_PUBLISHING_STATUS.APPROVED]: 'approved',
  [ACCOUNT_RESUME_PUBLISHING_STATUS.REJECTED]: 'rejected',
  [ACCOUNT_RESUME_PUBLISHING_STATUS.ON_REVIEW]: 'review',
  [ACCOUNT_RESUME_PUBLISHING_STATUS.HIDDEN]: 'hidden',
  [ACCOUNT_RESUME_PUBLISHING_STATUS.DRAFT]: 'draft',
}

export const ACCOUNT_RESUME_REASON_STATUSES: ReadonlyArray<string> = [
  ACCOUNT_RESUME_PUBLISHING_STATUS.REJECTED,
  ACCOUNT_RESUME_PUBLISHING_STATUS.DRAFT,
]
